import { module } from 'angular'
import asociarfacturasModule from './asociarfacturas/index.js'
import buscarimportesModule from './buscarimportes/index.js'
import catalogosexternosModule from './catalogosexternos/index.js'
import chequesModule from './cheques/index.js'
import clientescuentascontablesModule from './clientescuentascontables/index.js'
import polizasModule from './polizas/index.js'
import polizasexternasModule from './polizasexternas/index.js'
import reporteisnModule from './reporteisn/index.js'
import reportenominasmovimientosModule from './reportenominasmovimientos/index.js'
import reportesexternosModule from './reportesexternos/index.js'
import sharedModule from './shared/index.js'
import declaracionIsnModule from './declaracionIsn/index.js'

export default module('contabilidad', [
  asociarfacturasModule,
  buscarimportesModule,
  catalogosexternosModule,
  chequesModule,
  clientescuentascontablesModule,
  polizasModule,
  polizasexternasModule,
  reporteisnModule,
  reportenominasmovimientosModule,
  reportesexternosModule,
  sharedModule,
  declaracionIsnModule,
])



// WEBPACK FOOTER //
// ./src/contabilidad/module.js